module.exports = __webpack_public_path__ + "img/btn_foto.1fbe0293.png";